<!-- 已开发票扣款延期、豁免类签批申请 -->
<template>
	<div class="pages">
		<div v-for='(item, index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control == "Number"' :data-val='item'></Digit>
			<Choose v-if='item.Property.Control == "Contact"' @child-event='clickChoose' :data-val='item'></Choose>
			<Dates v-if='item.Property.Control == "Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control == "Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control == "Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control == "Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control == "File"' :data-val="item"></File>
			<Table v-if='item.Property.Control == "Table"' :data-val='item'></Table>
			<Selector v-if='item.Property.Control == "Selector"' @child-event='getSelectorVal' :data-val='item'>
			</Selector>
			<Textarea v-if='item.Property.Control == "Textarea"' :data-val='item'></Textarea>
		</div>


		<Button class="submit-process" v-on:click='submit' v-bind:disabled="isDisabled" size="large" type="primary"> 提交
		</Button>

		<Spin size="large" fix v-if="spinShow"></Spin>
	</div>
</template>

<script>
/**
 * Version 为Text文本组件
 */
import Digit from '../components/Number.vue'
// import Contact from '../components/Contact.vue';
import Dates from '../components/Date.vue';
import Version from '../components/Text.vue';
import Money from '../components/Money.vue';
import Tips from '../components/Tips.vue';
import File from '../components/File.vue';
import Table from '../components/Table.vue';
import Selector from '../components/Selector.vue';
import Textarea from '../components/Textarea.vue';
import Choose from '../components/Choose.vue';
import { getOptionValForDataVal } from '../utils/componentUtils'

import {
	initWxConfig
} from '../api/jssdk.js';
import wx from 'weixin-js-sdk'

import stringUtils from "../assets/js/stringUtil.js";
import { submitProcess, AllowApplyForVerify } from '@/api/approval'
var templateData = {
	TemplateContent: {
		Controls: []
	}
};
var logInfo = null;

var isSubmit = false;

import {
	formatDate
} from '@/utils/date'

export default {
	components: {
		// Contact,
		Dates,
		Version,
		Money,
		Tips,
		File,
		Table,
		Digit,
		Selector,
		Textarea,
		Choose
	},
	data() {
		return {
			"templateData": templateData,
			spinShow: true,
			isDisabled: false,
			flowId: null
		}
	},
	mounted() { //页面挂载
		initWxConfig(this);
		this.getTemplate();
		stringUtils.setAddIsShow(false);
	},
	created() {
	},
	methods: { //方法

		clickChoose(dataVal, name) {
			window.wx.invoke("selectEnterpriseContact", {
				"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
				"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
				"type": ["user"], // 必填，选择限制类型，指定department、user中的一个或者多个
				"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
			}, function (res) {
				if (res.err_msg == "selectEnterpriseContact:ok") {
					if (typeof res.result == 'string') {
						res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
					}
					var user = res.result.userList[0];
					dataVal.Values.push([user.id, user.name]);
					var userId = user.id; // 已选的成员列表
					dataVal.Value = user.name;
				}
			})
		},
		getTemplate: async function () {
			let that = this;

			// console.log(stringUtils.GetQueryString("templateId"))
			that.$http({
				url: that.$httpUrl.getTemplate + "?templateId=" + stringUtils.GetQueryString("templateId"),
				method: "get",
			}).then(async res => {
				if (res.data == null || res.data.ErrCode != 0) {
					that.$Message.error({ //error： 错误信息、success：成功、info：普通、warning：警告
						background: true,
						content: '模板获取错误'
					});
					return;
				}
				that.templateData = res.data.Body;
				if (that.templateData == null) {
					alert("模板获取错误");
					return;
				}
				logInfo = JSON.parse(localStorage.getItem('logInfo'));

				if (logInfo == null) {
					logInfo = JSON.parse(stringUtils.getCookies("logInfo"));
				}
				for (var i = 0; i < that.templateData.TemplateContent.Controls.length; i++) {
					if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "部门") {
						that.templateData.TemplateContent.Controls[i].Value = logInfo.DeptName;
					} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "人员") {
						that.templateData.TemplateContent.Controls[i].Value = logInfo.EmpName;
					} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "工号") {
						that.templateData.TemplateContent.Controls[i].Value = logInfo.EmpNo;
					} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "入职时间") {
						that.templateData.TemplateContent.Controls[i].Value = logInfo.InCompanyDate;
					} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "联系电话") {
						that.templateData.TemplateContent.Controls[i].Value = logInfo.Mobile;
					} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "流程条件") {
						that.templateData.TemplateContent.Controls[i].Value = logInfo.JobLevel <= -1;
						var ii = i;
						that.templateData.TemplateContent.Controls[ii].Value = -1;
						that.$http({
							url: that.$httpUrl.GetRelation + "/" + logInfo.EmpNo + "/employee-relation",
							method: "get",
						}).then(res => {
							var nodes = res.data.Body[0].Nodes;
							var isOk = false;
							if (logInfo.fullName.indexOf("商业地产部") > -1) {
								that.templateData.TemplateContent.Controls[ii].Value = 1;
								for (var k = 0; k < nodes.length; k++) {
									if (nodes[k].Items != null) {
										var items = nodes[k].Items;
										for (var p = 0; p < items.length; p++) {
											if (items[p].JobLevel >= 6 && items[p].JobLevel < 7 && !isOk) {
												that.templateData.TemplateContent.Controls[ii].Value = 1 + "." + (k + 1);
												isOk = true;
											}
										}
									}
								}
							} else if (logInfo.fullName.indexOf("二级市场营运中心") > -1 || logInfo.fullName.indexOf("代理") > -1) {
								that.templateData.TemplateContent.Controls[ii].Value = 2;
								if (logInfo.fullName.indexOf("非营业") > -1) {
									that.templateData.TemplateContent.Controls[ii].Value = 2 + ".1";
								} else {
									if (logInfo.JobLevel < 7) {
										for (var k = 0; k < nodes.length; k++) {
											if (nodes[k].Items != null) {
												var items = nodes[k].Items;
												for (var p = 0; p < items.length; p++) {
													if (items[p].JobLevel == 7 && !isOk) {
														that.templateData.TemplateContent.Controls[ii].Value = 2 + ".2" + (k + 1);
														isOk = true;
													}
												}
											}
										}
									}

								}
							} else if (logInfo.fullName.indexOf("房友圈") > -1 || logInfo.fullName.indexOf("藤云") > -1) {
								that.templateData.TemplateContent.Controls[ii].Value = 3;
								for (var k = 0; k < nodes.length; k++) {
									if (nodes[k].Items != null) {
										var items = nodes[k].Items;
										for (var p = 0; p < items.length; p++) {
											if (items[p].JobLevel == 7 && !isOk) {
												that.templateData.TemplateContent.Controls[ii].Value = 3 + "." + (k + 1);
												isOk = true;
											}
										}
									}
								}
							}else{
								//其他 防止 新媒体 提交不了
								that.templateData.TemplateContent.Controls[ii].Value = 5;
							}
							if (that.templateData.TemplateContent.Controls[ii].Value == -1) {
								this.Message({
									message: '没有申请权限',
									type: 'error',
									duration: 1000
								});
								this.isDisabled = true;
							}
						});
					} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "申请时间") {
						let date = new Date();
						that.templateData.TemplateContent.Controls[i].Value = formatDate(date, "yyyy-MM-dd");
					} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "职位") {
						that.templateData.TemplateContent.Controls[i].Value = logInfo.PositionName;
					} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text === "交房保证金额") {
						that.templateData.TemplateContent.Controls[i].IsShow = false;
					}
				}

				that.spinShow = false;
				this.templateData = await this.assignControlBySpNo(this.templateData, stringUtils.GetQueryString("spNo"));
			}, err => {

			});
		},
		getTextVal() {

		},
		getSelectorVal(val, name, type, dataVal) {
			const templateId = stringUtils.GetQueryString("templateId");
			var controls = this.templateData.TemplateContent.Controls;
			if ("是否包含交房保证金" === name) {
				let amountIsShow = false
				let opValue = getOptionValForDataVal(val, dataVal);
				if ("是" === opValue) {
					amountIsShow = true
				}
				if ("否" === opValue) {
					amountIsShow = false
				}
				for (let control of controls) {
					if (control.Property.Title[0].Text === "交房保证金额") {
						control.IsShow = amountIsShow
						control.Property.Require = amountIsShow ? 1 : 0
					}
				}
				return;
			}

			var i = 0;
			if (templateId == 'Bs7xbzNAeeBPD3ttT37HHJRe4KRc3bA5wURd7xTME') {
				// 是员工人事类盖章审批申请
				if (val == 'option-1595832288661' || val == 'option-1595832288662' || val == 'option-1595832288663') {
					for (i = 0; i < controls.length; i++) {
						if (controls[i].Property.Title[0].Text == '附件') {
							controls[i].Property.Require = 1;
							return;
						}
					}
				} else {
					for (i = 0; i < controls.length; i++) {
						if (controls[i].Property.Title[0].Text == '附件') {
							controls[i].Property.Require = 0;
							return;
						}
					}
				}
			}
		},
		submit() {
			//数据校验
			if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
				return;
			}
			for (let control of this.templateData.TemplateContent.Controls) {
				if (control.Property.Title[0].Text === "交房保证金额") {
					control.Property.Require = 0
				}
			}
			if (isSubmit) {
				this.Message({
					message: '已提交',
					type: 'warning',
					duration: 1000
				});
				return;
			}
			isSubmit = true;

			var SummaryList = [];
			var info = { SummaryInfo: [] }
			info.SummaryInfo = [];

			var control1 = this.templateData.TemplateContent.Controls.filter(t => { return t.Property.Title[0].Text == "项目名称" })[0]
			if (control1.Value != null && control1.Value.length > 0) {
				var info = { SummaryInfo: [] }
				info.SummaryInfo = [];
				info.SummaryInfo.push({ "Text": "内容：" + control1.Value, "Lang": "zh_CN" });
				SummaryList.push(info);
			}

			var control2 = this.templateData.TemplateContent.Controls.filter(t => { return t.Property.Title[0].Text == "部门" })[0]
			var info = { SummaryInfo: [] }
			info.SummaryInfo = [];
			info.SummaryInfo.push({ "Text": "申请部门：" + control2.Value, "Lang": "zh_CN" });
			SummaryList.push(info);


			var data = new Date();
			var month = data.getMonth() < 9 ? "0" + (data.getMonth() + 1) : data.getMonth() + 1;
			var date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
			var dateTime = data.getFullYear() + "-" + month + "-" + date;
			var info = { SummaryInfo: [] }
			info.SummaryInfo = [];
			info.SummaryInfo.push({ "Text": "申请时间：" + dateTime, "Lang": "zh_CN" });
			SummaryList.push(info);
			this.templateData.SummaryList = SummaryList;

			// //提交
			submitProcess(stringUtils.GetQueryString("templateId"), logInfo.EmpNo, this.spNo, this.templateData).then(response => {

				isSubmit = false;
				this.$router.push("/index");
			})
		}
	}
}
</script>

<style scoped lang="less">
.pages {
	padding-bottom: 14px;
}
</style>
